class CartItems extends HTMLElement {
    constructor() {
        super();

        this.cartCountDown = document.getElementById(`CartCountdown-${this.dataset.section}`)
        this.giftCardElement = document.getElementById('is-a-gift')
        this.giftCardButton = document.getElementById('cart-gift-wrapping')
        this.removeButtons = document.querySelectorAll('[data-cart-remove]')
        this.toCheckoutButton = document.getElementById('cart-checkout')
        this.couponCodeInput = document.getElementById('cart-coupon-code')
        this.cartNoteInput = document.getElementById('cart-note')
        this.checkTerms = document.getElementById('cart_conditions')
        this.stickyCheckoutBtn = document.querySelector('[data-sticky-checkout-btn]')
        this.stickyCheckoutButton = document.querySelector('[data-sticky-checkout]')
        this.cartActionsElement = document.querySelector('.cart-actions')

        this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))
        this.stickyCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))

        this.initToCheckoutButtonDisabling()
        this.initCartCountdown()
        if (this.giftCardElement) this.initGiftCardElement()
        this.initGiftCardManipulation()
        this.initStickyCheckoutButton()
  }

    initGiftCardElement() {
        const isChecked = this.giftCardButton?.dataset.isChecked
        if (isChecked === 'true') {
            const variantId = this.giftCardButton?.dataset.giftId
            const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
            const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

            this.giftCardElement.style.display = 'none'
            giftCardRemoveButton?.addEventListener('click', () => {
                this.giftCardButton.dataset.isChecked = 'false'
            })

            giftCardQuantityInput?.addEventListener('change', (e) => {
                const value = Number(e.target.value)
                if (value  <= 0) {
                    this.giftCardButton.dataset.isChecked = 'false'
                }
            })
        } else {
          this.giftCardElement.style.display = 'flex'
        }
    }

    initGiftCardManipulation() {
        if (this.giftCardButton) {
            this.giftCardButton.removeEventListener('click', this.onAddGiftCardClick.bind(this))
            this.giftCardButton.addEventListener('click', this.onAddGiftCardClick.bind(this))
        }
    }

    onAddGiftCardClick(e) {
        e.preventDefault()
        e.stopPropagation()
        this.giftCardButton.dataset.isChecked = 'true'
    }

    initToCheckoutButtonDisabling() {
        if (this.checkTerms) {
            window.addEventListener('load', () => {
                this.toCheckoutButton.disabled = !this.checkTerms.checked
                if (this.stickyCheckoutButton) {
                    this.stickyCheckoutButton.disabled = !this.checkTerms.checked
                }
            })
            
            // 同步 checkbox 状态到吸底按钮
            this.checkTerms.addEventListener('change', () => {
                if (this.stickyCheckoutButton) {
                    this.stickyCheckoutButton.disabled = !this.checkTerms.checked
                }
            })
        }
    }

    initStickyCheckoutButton() {
        if (!this.stickyCheckoutBtn || !this.cartActionsElement) return

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // cart-actions 在视口内，隐藏吸底按钮
                    this.stickyCheckoutBtn.classList.remove('open-sticky')
                } else {
                    // cart-actions 不在视口内，显示吸底按钮
                    this.stickyCheckoutBtn.classList.add('open-sticky')
                }
            })
        }, {
            root: null,
            threshold: 0,
            rootMargin: '0px'
        })

        observer.observe(this.cartActionsElement)
    }

    async handleToCheckoutPage(e) {
        e.preventDefault()

        try {
            // saving coupon
            const couponCode = this.couponCodeInput?.value 
            if (couponCode) {
                localStorage.setItem('storedDiscount', couponCode)
                const couponRes =  await fetch(`/discount/${couponCode}`)
                const text1 = await couponRes.text()
            }
            
            // saving cart note
            const cartNote = this.cartNoteInput?.value
            if (cartNote) {
                const cartNoteBody = JSON.stringify({ note: cartNote })
                const cartNoteRes = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body: cartNoteBody }})
                const text2 = await cartNoteRes.text()
            }

        } catch(error) {
            console.error(`Error: ${error.message}`)
        }

        let checkoutHref = this.toCheckoutButton.dataset.href;
        if (checkoutHref == null) {
            checkoutHref = `${window.routes?.root ? window.routes.root : ""}/checkout`;
        }
        
        this.toCheckoutButton.classList.add('is-loading');

        const htmlContent = document.documentElement.outerHTML;
        if(!htmlContent.includes('cdn-sf.vitals.app')){
            window.location = checkoutHref;
        } else {
            setTimeout(() => {
                window.location = checkoutHref;
            }, 1000);
        }
    } 

    initCartCountdown(){
        if(!this.cartCountDown) return;

        if(!this.cartCountDown.classList.contains('is-running')){
            const duration = this.cartCountDown.getAttribute('data-cart-countdown') * 60
            const element = this.cartCountDown.querySelector('.time');

            this.cartCountDown.classList.add('is-running');
            this.startTimerCartCountdown(duration, element);
        }
    }

    startTimerCartCountdown(duration, element){
        var timer = duration, minutes, seconds, text;

        var startCoundown = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            text = minutes + ":" + seconds;

            element.innerText = text;

            if (--timer < 0) {
                clearInterval(startCoundown);
                this.cartCountDown.remove();
            }
        }, 1000);
    }
}

customElements.define('cart-items', CartItems);

class Accordion extends HTMLElement {
    constructor() {
        super();
        this.header = this.firstElementChild;
        this.content = this.lastElementChild;

        this.header.addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open(event);
    }

    open(event) {
        this.setAttribute('open', true);
        this.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        $(this.content).slideDown()
    }

    close() {
        this.removeAttribute('open');
        this.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
        $(this.content).slideUp()
    }
}

customElements.define('accordion-block', Accordion);

class CouponCode extends HTMLElement {
    constructor() {
        super();
        if (localStorage.getItem('storedDiscount')) {
            this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
        }
        this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
            this.val = this.querySelector('input[name="discount"]').value.trim();

            const discountCode = this.val || 'null';
            const applyBtn = event.currentTarget;

            const originalText = applyBtn.textContent;
            applyBtn.disabled = true;
            applyBtn.textContent = '...';

            // 每次重新请求时重置错误提示
            const noMatchEl = this.querySelector('.no-match-disct');
            if (noMatchEl) {
                noMatchEl.style.display = 'none';
            }

            fetch(`/discount/${discountCode}`)
                .then((response) => response.text())
                .then(() => {
                    // /discount/{code} 始终返回 200，需通过购物车验证折扣是否真正生效
                    return fetch('/cart.js').then((r) => r.json());
                })
                .then((cart) => {
                    // 检查购物车级别折扣是否被接受（大小写不敏感）
                    const appliedDiscounts = cart.cart_level_discount_applications || [];
                    const discountApplied = appliedDiscounts.some(
                        (d) => d.title?.toLowerCase() === discountCode.toLowerCase()
                    );

                    if (!discountApplied) {
                        throw new Error('Invalid discount code');
                    }

                    // 仅在折扣码验证成功后才缓存
                    localStorage.setItem('storedDiscount', this.val);

                    if (window.sharedFunctions?.updateCart) {
                        window.sharedFunctions.updateCart(cart);
                    }
                })
                .catch((error) => {
                    console.error('Discount code application failed:', error);
                    const noMatchEl = this.querySelector('.no-match-disct');
                    if (noMatchEl) {
                        noMatchEl.style.display = 'block';
                    }
                })
                .finally(() => {
                    applyBtn.disabled = false;
                    applyBtn.textContent = originalText;
                });
        });
    }
}

if (!customElements.get('coupon-code')) {
    customElements.define('coupon-code', CouponCode);
}

